import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  healthPlan: null,
};
export const healthPlanSlice = createSlice({
  name: "app",
  initialState,
  reducers: {
    setHealthPlan: (state, action) => {
      state.healthPlan = action.payload;
    },
    resetHealthPlan: (state) => {
      state.healthPlan = initialState.healthPlan;
    },
  },
});

export const { setHealthPlan, resetHealthPlan } = healthPlanSlice.actions;
export default healthPlanSlice.reducer;
